/* Surcharges des skins liées à l'affichage RTL */
import {IReg, REG} from "/@lib@/commons/registry.js";

export function ovrReg(reg: IReg<any>) {
	/** FIXME : à supprimer qd utilisation de inset-inline-start/inset-inline-end */
	reg.overlaySkin("box/head-body", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
		box-btnreplace-in {
			left: unset;
			right: 0;
		}
	`);

	reg.overlaySkin("box-collaps/collapsed", REG.LEVELAUTH_RTL_OVR, /* language=CSS */ `
	  #decollapser {
			transform: scaleX(-1);
	  }
	`);

}


